module.exports = __webpack_public_path__ + "static/media/mov.7e0176c4.png";